
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hB2SF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AttachmentGridView", () => $3750f5d7438feb32$export$5ab37d40c5d5b3c9);
$parcel$export(module.exports, "default", () => $3750f5d7438feb32$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $lFKmC = parcelRequire("lFKmC");

var $cEHh7 = parcelRequire("cEHh7");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6M6vE = parcelRequire("6M6vE");

var $7qyDl = parcelRequire("7qyDl");

var $dfJ3P = parcelRequire("dfJ3P");

var $2gCtH = parcelRequire("2gCtH");

var $dPP9r = parcelRequire("dPP9r");

var $hxqfC = parcelRequire("hxqfC");

var $eV94v = parcelRequire("eV94v");

var $iowjP = parcelRequire("iowjP");

var $8wXP2 = parcelRequire("8wXP2");

var $dJq4H = parcelRequire("dJq4H");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");

var $gDpUM = parcelRequire("gDpUM");

var $2HbP2 = parcelRequire("2HbP2");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");

var $gqJ3C = parcelRequire("gqJ3C");

var $8G097 = parcelRequire("8G097");

var $fyfDQ = parcelRequire("fyfDQ");

var $kAwig = parcelRequire("kAwig");

var $7GvHY = parcelRequire("7GvHY");

var $9Qvrl = parcelRequire("9Qvrl");
const $3750f5d7438feb32$var$AttachmentGridViewInternal = (props)=>{
    const intl = (0, $koVbs.default)();
    const { updateTotalItems: updateTotalItems, gridSize: gridSize, startIndex: startIndex } = (0, $7GvHY.useGridContext)();
    const isFirstRender = (0, $5uXOq.useRef)(true);
    const { isMobile: isMobile, isPreview: isPreview, mediaContext: mediaContext, onScrollToComments: onScrollToComments, onScrollToWorklogs: onScrollToWorklogs, viewMediaClientConfig: viewMediaClientConfig } = props;
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const shouldEnableDownloadButton = (0, $17Gip.useCanDownloadAttachments)(projectKey);
    const [isFetching] = (0, $gqJ3C.useAttachmentStoreIsFetching)(issueKey);
    const [{ value: { attachments: attachments = [], totalCount: totalCount }, error: error }, { refreshAttachments: refreshAttachments }] = (0, $7qyDl.useIssueAttachments)(issueKey, {
        maxResults: gridSize
    });
    const canDeleteAttachmentMapModal = (0, $6M6vE.useCanDeleteAttachment)();
    const items = (0, $5uXOq.useMemo)(()=>attachments.map((attachment)=>{
            const identifier = {
                mediaItemType: 'file',
                id: attachment.mediaApiFileId,
                attachmentId: attachment.id,
                ...mediaContext.viewContext && mediaContext.viewContext.collection !== null ? {
                    collectionName: mediaContext.viewContext.collection
                } : {}
            };
            const actions = (0, $8G097.getActionsForAttachment)(attachment.id, attachment.parentName, attachment.parentId, canDeleteAttachmentMapModal[attachment.id], intl, issueKey, onScrollToComments, onScrollToWorklogs);
            return {
                filename: attachment.filename,
                identifier: identifier,
                createdDate: attachment.createdDate ? attachment.createdDate * 1000 : 0,
                mimetype: attachment.mimetype,
                selectable: false,
                actions: actions,
                isLazy: !isMobile,
                isPreview: isPreview,
                hasRestrictedParent: attachment.hasRestrictedParent
            };
        }), [
        attachments,
        intl,
        isMobile,
        issueKey,
        mediaContext.viewContext,
        onScrollToComments,
        onScrollToWorklogs,
        canDeleteAttachmentMapModal,
        isPreview
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRefreshAttachments = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(refreshAttachments, (0, $9Qvrl.DEBOUNCE_DURATION)), [
        refreshAttachments
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        refreshAttachments(issueKey, {
            startAt: startIndex,
            maxResults: gridSize
        });
    }, [
        issueKey,
        refreshAttachments,
        startIndex,
        gridSize
    ]);
    /**
   * Refresh attachments only on first render.
   *
   * There is a issue with the attachments service, that it doesn't refetch
   * attachments using `useIssueAttachments` hook when totalCount is available.
   * This is a workaround to refresh attachments when the component is mounted
   * and totalCount is available.
   */ (0, $5uXOq.useEffect)(()=>{
        if (isFirstRender.current && totalCount !== undefined && !isFetching) {
            refreshAttachments(issueKey, {
                startAt: startIndex,
                maxResults: gridSize
            });
            isFirstRender.current = false;
        }
    }, [
        issueKey,
        refreshAttachments,
        startIndex,
        gridSize,
        totalCount,
        isFetching
    ]);
    // Refresh attachments when there is a changes ingrid size of page number
    (0, $5uXOq.useEffect)(()=>{
        debouncedRefreshAttachments(issueKey, {
            startAt: startIndex,
            maxResults: gridSize
        });
    }, [
        issueKey,
        debouncedRefreshAttachments,
        startIndex,
        gridSize
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateTotalItems(totalCount);
    }, [
        updateTotalItems,
        totalCount
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dfJ3P.default), {
        shouldHideImage: true,
        onClick: onClick
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fyfDQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAwig.default), {
        items: items,
        mediaClientConfig: viewMediaClientConfig,
        shouldEnableDownloadButton: shouldEnableDownloadButton
    })));
};
const $3750f5d7438feb32$export$5ab37d40c5d5b3c9 = (props)=>{
    const { viewMediaClientConfig: viewMediaClientConfig } = props;
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const shouldEnableDownloadButton = (0, $17Gip.useCanDownloadAttachments)(projectKey);
    const mediaClientConfig = (0, $5uXOq.useMemo)(()=>({
            ...viewMediaClientConfig,
            enforceDataSecurityPolicy: (0, $4R6GH.fg)('block_attachment_download_on_data_export_dsp_rule') && !shouldEnableDownloadButton
        }), [
        shouldEnableDownloadButton,
        viewMediaClientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3750f5d7438feb32$var$AttachmentGridViewInternal, {
            ...props,
            viewMediaClientConfig: mediaClientConfig
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientProvider), {
            clientConfig: mediaClientConfig
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3750f5d7438feb32$var$AttachmentGridViewInternal, {
            ...props,
            viewMediaClientConfig: mediaClientConfig
        })));
};
const $3750f5d7438feb32$var$AttachmentGridViewConnect = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $dPP9r.default), (0, $hxqfC.connect)((state)=>({
        mediaContext: (0, $gDpUM.mediaContextSelector)(state),
        isMobile: (0, $a1ky2.isMobileSelector)(state),
        isPreview: (0, $bcoYn.isPreviewSelector)(state)
    }), (dispatch)=>({
        onCardCoverShow: (currentAttachmentId, newAttachmentId)=>{
            dispatch((0, $eV94v.cardCoverUpdateRequest)(currentAttachmentId, newAttachmentId));
        },
        onCardCoverHide: (currentAttachmentId)=>{
            dispatch((0, $eV94v.cardCoverUpdateRequest)(currentAttachmentId));
        },
        onScrollToComments: ()=>{
            dispatch((0, $iowjP.scrollToAttachmentComment)());
        },
        onScrollToWorklogs: ()=>{
            dispatch((0, $iowjP.scrollToAttachmentWorklog)());
        },
        onViewRefresh: ()=>{
            dispatch((0, $dJq4H.fetchViewContextRequest)());
        },
        onUploadRefresh: ()=>{
            dispatch((0, $8wXP2.fetchUploadContextRequest)());
        }
    })))($3750f5d7438feb32$export$5ab37d40c5d5b3c9);
var $3750f5d7438feb32$export$2e2bcd8739ae039 = $3750f5d7438feb32$var$AttachmentGridViewConnect;

});
parcelRegister("kAwig", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9a3e6f137cc2ba5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8Ppwv = parcelRequire("8Ppwv");

var $4R6GH = parcelRequire("4R6GH");

var $4h3hM = parcelRequire("4h3hM");

var $9Qvrl = parcelRequire("9Qvrl");

var $7nXXc = parcelRequire("7nXXc");
const $c9a3e6f137cc2ba5$var$cardDimensions = {
    width: '100%',
    height: (0, $9Qvrl.GRID_ITEM_DIMENSIONS).height
};
const $c9a3e6f137cc2ba5$var$MediaCardItems = ({ items: items, mediaClientConfig: mediaClientConfig, shouldEnableDownloadButton: shouldEnableDownloadButton })=>{
    const attachmentIdentifiers = items.map((item)=>item.identifier);
    return items.map((item)=>{
        const isInternalAttachment = item.hasRestrictedParent;
        return (0, $4R6GH.fg)('attachment_grid_view_media_card') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nXXc.default), {
            item: item,
            attachmentIdentifiers: attachmentIdentifiers,
            mediaClientConfig: mediaClientConfig,
            shouldEnableDownloadButton: shouldEnableDownloadButton
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9a3e6f137cc2ba5$var$mediaCardStyle,
            key: item.identifier.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ppwv.default), {
            mediaClientConfig: mediaClientConfig,
            mediaViewerItems: attachmentIdentifiers,
            useInlinePlayer: false,
            shouldOpenMediaViewer: true,
            dimensions: $c9a3e6f137cc2ba5$var$cardDimensions,
            featureFlags: (0, $4h3hM.mediaFeatureFlags)(),
            titleBoxBgColor: isInternalAttachment ? "var(--ds-background-accent-purple-subtle, #9F8FEF)" : undefined,
            titleBoxIcon: isInternalAttachment ? 'LockFilledIcon' : undefined,
            shouldEnableDownloadButton: !(0, $4R6GH.fg)('block_attachment_download_on_data_export_dsp_rule') || shouldEnableDownloadButton,
            ...item,
            testId: `issue.views.issue-base.content.attachment.grid-view.attachment-id.${item.identifier.attachmentId}`
        }));
    });
};
const $c9a3e6f137cc2ba5$var$mediaCardStyle = (0, $8CUq3.xcss)({
    // https://hello.atlassian.net/wiki/spaces/DST/pages/3225764567/Guide+for+Migrating+to+Spacing+Tokens#The-value-I%E2%80%99m-migrating-is-too-large-to-be-represented-with-a-token
    minWidth: '138px',
    width: '100%',
    height: '130px',
    cursor: 'pointer'
});
var $c9a3e6f137cc2ba5$export$2e2bcd8739ae039 = $c9a3e6f137cc2ba5$var$MediaCardItems;

});
parcelRegister("7nXXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $814f9f21f0d6acb8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $8Ppwv = parcelRequire("8Ppwv");

var $3bDjY = parcelRequire("3bDjY");

var $2I6Ss = parcelRequire("2I6Ss");

var $4lTz8 = parcelRequire("4lTz8");

var $jzW7G = parcelRequire("jzW7G");

var $4R6GH = parcelRequire("4R6GH");

var $4h3hM = parcelRequire("4h3hM");

var $9Qvrl = parcelRequire("9Qvrl");

var $7pQkX = parcelRequire("7pQkX");

var $lbXbu = parcelRequire("lbXbu");
const { height: $814f9f21f0d6acb8$var$height, infoSectionHeight: $814f9f21f0d6acb8$var$infoSectionHeight } = (0, $9Qvrl.GRID_ITEM_DIMENSIONS);
const $814f9f21f0d6acb8$var$cardDimensions = {
    width: '100%',
    height: $814f9f21f0d6acb8$var$height - $814f9f21f0d6acb8$var$infoSectionHeight
};
const $814f9f21f0d6acb8$var$placeholderText = ' ';
const $814f9f21f0d6acb8$var$MediaCardItem = ({ item: item, mediaClientConfig: mediaClientConfig, shouldEnableDownloadButton: shouldEnableDownloadButton, attachmentIdentifiers: attachmentIdentifiers })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $814f9f21f0d6acb8$var$mediaCardStyle,
        key: item.identifier.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ppwv.default), {
        mediaClientConfig: mediaClientConfig,
        mediaViewerItems: attachmentIdentifiers,
        useInlinePlayer: false,
        shouldOpenMediaViewer: true,
        dimensions: $814f9f21f0d6acb8$var$cardDimensions,
        featureFlags: (0, $4h3hM.mediaFeatureFlags)(),
        disableOverlay: true,
        shouldEnableDownloadButton: !(0, $4R6GH.fg)('block_attachment_download_on_data_export_dsp_rule') || shouldEnableDownloadButton,
        ...item,
        testId: `issue.views.issue-base.content.attachment.grid-view.attachment-id.${item.identifier.attachmentId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbXbu.TitleBoxWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbXbu.TitleBoxHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        tag: "span",
        content: item.filename
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4lTz8.Truncate), {
        text: item.filename || '',
        startFixedChars: 3,
        endFixedChars: 4
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbXbu.TitleBoxFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, item.createdDate ? (0, $7pQkX.formatDate)(item.createdDate, 'en') : $814f9f21f0d6acb8$var$placeholderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $814f9f21f0d6acb8$var$fileTypeIconStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2I6Ss.MimeTypeIcon), {
        size: "small",
        mimeType: item.mimetype,
        mediaType: (0, $jzW7G.getMediaTypeFromMimeType)(item.mimetype || ''),
        name: item.filename,
        testId: "issue-view-base.content.attachment.grid-view.ui.components.media-card.mime-type-icon"
    }))))));
const $814f9f21f0d6acb8$var$mediaCardStyle = (0, $8CUq3.xcss)({
    // https://hello.atlassian.net/wiki/spaces/DST/pages/3225764567/Guide+for+Migrating+to+Spacing+Tokens#The-value-I%E2%80%99m-migrating-is-too-large-to-be-represented-with-a-token
    minWidth: '138px',
    width: '100%',
    height: '130px',
    cursor: 'pointer',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    overflow: 'hidden',
    border: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $814f9f21f0d6acb8$var$fileTypeIconStyle = (0, $8CUq3.xcss)({
    filter: 'grayscale(1)',
    width: '16px',
    height: '16px'
});
var $814f9f21f0d6acb8$export$2e2bcd8739ae039 = $814f9f21f0d6acb8$var$MediaCardItem;

});
parcelRegister("2I6Ss", function(module, exports) {

$parcel$export(module.exports, "MimeTypeIcon", () => $ce8d1decd795d05b$export$875d423332b93b5f);
/* mime-type-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1xbJn = parcelRequire("1xbJn");

var $lkyzf = parcelRequire("lkyzf");
var $8DdVX = parcelRequire("8DdVX");

var $VSDnB = parcelRequire("VSDnB");
const $ce8d1decd795d05b$var$iconWrapperStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $ce8d1decd795d05b$var$iconWrapperStyles = null;
const $ce8d1decd795d05b$export$875d423332b93b5f = ({ mediaType: mediaType = 'unknown', mimeType: mimeType = 'unknown', name: name = 'unknown', testId: testId, size: size = 'large' })=>{
    // retrieve mimetype icon and label
    const iconInfo = (0, $1xbJn.getMimeIcon)(mimeType, name);
    // a corresponding mimetype icon and label was found.
    if (iconInfo) {
        const Icon = iconInfo.icon;
        return (0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            "data-type": iconInfo.label,
            className: (0, $bwpsq.default)([
                "_1e0c116y",
                $ce8d1decd795d05b$var$iconWrapperStyleMap[size ?? 'small']
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                label: iconInfo.label
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lkyzf.IconWrapper), {
            "data-testid": testId,
            "data-type": iconInfo.label,
            size: size,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                label: iconInfo.label
            })
        });
    }
    // no corresponding mimetype icon/label was found.
    // Hence, return a mediatype (image/doc/audio/video/unknown) icon
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8DdVX.MediaTypeIcon), {
        testId: testId,
        type: mediaType,
        size: size
    });
};

});

parcelRegister("7pQkX", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $10bc4bea73cd7f55$export$3ae94a2503e890a1);

var $7qZ1x = parcelRequire("7qZ1x");
const $10bc4bea73cd7f55$export$f34a3540a1aa68e4 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};
const $10bc4bea73cd7f55$export$20911720278c41 = ({ day: day, month: month, year: year })=>{
    // const formattedDayPeriod = dayPeriod.replace(/\./g, '').replace(/\s/g, '');
    return `${day} ${month}, ${year}`;
};
const $10bc4bea73cd7f55$export$3ae94a2503e890a1 = (timestamp, locale = 'en')=>{
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale, $10bc4bea73cd7f55$export$f34a3540a1aa68e4);
    return $10bc4bea73cd7f55$export$20911720278c41(l10n.formatToParts(timestamp));
};

});

parcelRegister("lbXbu", function(module, exports) {

$parcel$export(module.exports, "TitleBoxWrapper", () => $a8693a3cd08dfcba$export$213c428ce4ec143c);
$parcel$export(module.exports, "TitleBoxHeader", () => $a8693a3cd08dfcba$export$43970d913b015380);
$parcel$export(module.exports, "TitleBoxFooter", () => $a8693a3cd08dfcba$export$1004da4fc5583975);
/* title-box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $a8693a3cd08dfcba$var$titleBoxWrapperStyles = null;
const $a8693a3cd08dfcba$export$213c428ce4ec143c = ({ children: children })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        id: "titleBoxWrapper",
        "data-testid": "issue-view-base.content.attachment.grid-view.ui.components.media-card.media-title-box",
        className: (0, $bwpsq.default)([
            "_11c81o8v _bfhkvuon _80om1kw7 _lcxvglyw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc"
        ])
    }, children);
};
const $a8693a3cd08dfcba$var$infoStyles = null;
const $a8693a3cd08dfcba$export$43970d913b015380 = ({ children: children })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        id: "titleBoxHeader",
        "data-testid": "issue-view-base.content.attachment.grid-view.ui.components.media-card.title-box-header",
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c"
        ])
    }, children);
};
const $a8693a3cd08dfcba$var$titleBoxFooterStyle = null;
const $a8693a3cd08dfcba$export$1004da4fc5583975 = ({ children: children })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        id: "titleBoxFooter",
        "data-testid": "issue-view-base.content.attachment.grid-view.ui.components.media-card.title-box-footer",
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c",
            "_4t3if6fq _1e0c1txw _1bah1yb4 _4cvr1h6o _syaz131l"
        ])
    }, children);
};

});





//# sourceMappingURL=async-attachment-grid-view.73bc76b9.js.map
